import { API, graphqlOperation } from "aws-amplify";
import BaseService from "./BaseService";
import {
  createAdhocAgreement,
  createAdhocProject,
  deleteAdhocAgreementFile,
  toggleAdhocProjectStatus,
  updateAdhocAgreement,
  uploadAdhocAgreementFile
} from "./graphql/mutations";
import {
  getAdhocAgreement,
  getAdhocAgreements,
  getAdhocProjects
} from "./graphql/queries";
import Amplify from "aws-amplify";
import { default as config } from "../config";

Amplify.configure({
  Auth: {
    identityPoolId: config.aws.identitypoolid,
    region: config.aws.cognitoregion,
    userPoolId: config.aws.userpoolid,
    userPoolWebClientId: config.aws.webclientid
  },
  API: {
    aws_appsync_graphqlEndpoint: config.aws.apiurl,
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
  },
  aws_appsync_graphqlEndpoint: config.aws.apiurl,
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
});

interface CreateAdhocProjectInput {
  name: string;
}

class AdhocAgreementsService extends BaseService {
  async createAdhocAgreement(createAdhocAgreementInput: any) {
    console.log("createAdhocAgreementInput", createAdhocAgreementInput);
    try {
      const { data } = (await API.graphql(
        graphqlOperation(createAdhocAgreement, { createAdhocAgreementInput })
      )) as any;
      return data.createAdhocAgreement;
    } catch (err) {
      console.error("Error creating adhoc agreement", err);
      throw err;
    }
  }

  async getAdhocAgreements({
    page,
    rowsPerPage,
    searchText,
    status,
    projectId
  }: {
    page: number;
    rowsPerPage: number;
    searchText?: string;
    status?: string;
    projectId?: string;
  }) {
    try {
      const { data } = (await API.graphql(
        graphqlOperation(getAdhocAgreements, {
          getAdhocAgreementsInput: {
            page,
            rowsPerPage,
            searchText,
            status,
            projectId
          }
        })
      )) as any;
      return data.getAdhocAgreements;
    } catch (err) {
      console.error("Error getting adhoc agreements", err);
    }
  }

  async getAdhocProjects({
    rowsPerPage,
    page,
    searchText
  }: {
    rowsPerPage: number;
    page: number;
    searchText?: string;
  }) {
    try {
      const { data } = (await API.graphql(
        graphqlOperation(getAdhocProjects, {
          getAdhocProjectsInput: { rowsPerPage, page, searchText }
        })
      )) as any;
      return data.getAdhocProjects;
    } catch (err) {
      console.error("Error getting adhoc projects", err);
    }
  }

  async createAdhocProject(createAdhocProjectInput: CreateAdhocProjectInput) {
    try {
      const { data } = (await API.graphql(
        graphqlOperation(createAdhocProject, { createAdhocProjectInput })
      )) as any;
      return data.createAdhocProject;
    } catch (err) {
      throw Error((err as any).errors[0].message);
    }
  }

  async updateAdhocAgreement(updateAdhocAgreementInput: any) {
    console.log("updateAdhocAgreementInput", updateAdhocAgreementInput);
    try {
      const { data } = (await API.graphql(
        graphqlOperation(updateAdhocAgreement, { updateAdhocAgreementInput })
      )) as any;
      return data.updateAdhocAgreement;
    } catch (err) {
      console.log("err", err);
      console.error("Error updating adhoc agreement", err);
    }
  }

  async toggleAdhocProjectStatus(toggleAdhocProjectStatusInput: {
    id: number;
  }) {
    try {
      const { data } = (await API.graphql(
        graphqlOperation(toggleAdhocProjectStatus, {
          toggleAdhocProjectStatusInput
        })
      )) as any;
      return data.toggleAdhocProjectStatus;
    } catch (err) {
      console.log("Error toggling adhoc project status", err);
    }
  }

  async getAdhocAgreement(getAdhocAgreementInput: { id: number }) {
    try {
      const { data } = (await API.graphql(
        graphqlOperation(getAdhocAgreement, { getAdhocAgreementInput })
      )) as any;
      console.log("data: ", data);
      console.log("data.getAdhocAgreement", data.getAdhocAgreement);
      return data.getAdhocAgreement;
    } catch (err) {
      console.error("Error getting adhoc agreement", err);
    }
  }

  async uploadAdhocAgreementFile(uploadAdhocAgreementFileInput: {
    adhocAgreementId: number;
    fileName: string;
    fileTypeExtension: string;
  }) {
    try {
      const { data } = (await API.graphql(
        graphqlOperation(uploadAdhocAgreementFile, {
          uploadAdhocAgreementFileInput
        })
      )) as any;
      return data.uploadAdhocAgreementFile;
    } catch (err) {
      console.error("Error uploading adhoc agreement file", err);
    }
  }

  async deleteAdhocAgreementFile(deleteAdhocAgreementFileInput: {
    id: number;
  }) {
    console.log(
      "adhocAgreementService - deleteAdhocAgreementFile: ",
      deleteAdhocAgreementFileInput
    );
    try {
      const { data } = (await API.graphql(
        graphqlOperation(deleteAdhocAgreementFile, {
          deleteAdhocAgreementFileInput
        })
      )) as any;
      return data.deleteAdhocAgreementFile;
    } catch (err) {
      console.error("Error deleting adhoc agreement file", err);
    }
  }
}

export const adhocAgreementsService = new AdhocAgreementsService();
export default adhocAgreementsService;
